module.exports = __webpack_public_path__ + "static/img/SWAN_Logo.b04461f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/SWAN_Logo.png
// module id = PBJY
// module chunks = 0